<template>
  <!--课程详情-->

  <div>
    <div v-if="!isApp && row.show_status==2" style="text-align: center">
      <van-empty description="课程仅在啦啦操GOAPP可浏览" />
      <van-button
        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
        style="width: 3rem"
        size="normal"
        round
        @click="onDownload()"
        >下载啦啦操GO APP</van-button
      >
    </div>
  <div v-if="isApp&&!row.id_cert  && row.show_status==2"  style="text-align: center">
    <van-empty description="您还未实名认证，请认证后浏览课程资源" />
    <van-button
      color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
      style="width: 3rem"
      size="normal"
      round
      v-rblink="{ name: 'MyInfo' }"
      >立即实名认证</van-button
    >
  </div>

  <div v-if="isApp&&!row.danwei_cert  && row.show_status==2"  style="text-align: center">
    <van-empty description="您还未进行单位认证，请认证后浏览课程资源" />
    <van-button
      color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
      style="width: 3rem"
      size="normal"
      round
      v-rblink="{ name: 'MyInfo' }"
      >立即单位认证</van-button
    >
  </div>


  <div v-if="(isApp&&row.id_cert&&row.danwei_cert )|| row.show_status==1" class="box">
  <!-- <div   class="box"> -->
    <div>
      <img class="course—pic" :src="row.pic_url" alt v-if="!paly_show" />
      <video width="100%" controls ref="videos" v-else>
        <source  id="playVideosss" :src="play_url" />
      </video>
    </div>

        <div class="course-detail"  >
          <div class="course-title-box">
            <div class="course-detail-title">{{row.title}}</div>
            <div class="course-detail-info" v-if="row.need_pay=='1'">免费</div>
            <div class="course-detail-info" v-else>
              <span class="course-price">¥{{row.price}}</span>
              <span class="course-validity">有效期 {{row.pay_days}}天</span>
            </div>
            <div class="course-play">
              <span class="course-num">视频 {{row.items.length}}</span>
              <span class="course-play-num">播放{{row.views_count}}</span>
            </div>
          </div>
          <div class="course-content">  

            <div class="content" v-html="row.content">
              <!-- {{ row.content }} -->
            </div>
          </div>
        </div> 

        <div class="directory" >
          <van-steps
            direction="vertical"
            :active="videoActive"
            active-icon="checked"
            inactive-icon="circle"
          >
            <van-step v-for="(item,i) in row.items" :key="i">
              <p class="course-title" @click="onPlayItems(i)">{{ item.title }}</p>
              <p class="course-info" @click="onPlayItems(i)">{{item.views_count}}人播放</p>
            </van-step>
          </van-steps>
          <div v-if="row.items.length==0">
            <van-empty description="暂时还没上传视频!" />
          </div>



        </div>

            <div class="savebtn" v-if="paly_show" >
                <van-button
                        v-if='!is_daka'
                        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                        style="width: 3rem"
                        size="normal" round  loading-text="提交中..." @click="daka">我要打卡</van-button>

          <van-button
          v-else
              style="width: 3rem"
              size="normal" native-type="button" round  >我已打卡
          </van-button>
            </div>
    <!-- 底部付费 -->
    <div class="course-bottom" v-if="row.need_pay=='2'">
      <div
        style="display: flex;justify-content: space-between;align-items: center;padding:0 10px;height:62px"
      >
        <div style="display: flex;align-items: center;">
          <span class="bottom-course">课程</span>
          <span class="bottom-course-price">¥{{row.price}}</span>
        </div>
        <div class="course-pay" @click="onPlayShwo">立即购买</div>
      </div>
    </div>
    <van-overlay :show="pay_show" @click="pay_show = false">
      <div class="wrapper" @click.stop>
        <div class="block">
          <div style="flex: 1;display: flex; justify-content: center;flex-direction: column;">
            <p>本视频需要付费开通</p>
            <p>您可以选择在线支付或者使用激活卡</p>
          </div>
          <div class="pay-show-bottom">
            <span class="no-pay" @click="pay_show=false">不看了</span>
            <span class="on-pay" @click="onPlayShwo">立即开通</span>
          </div>
        </div>
      </div>
    </van-overlay>

    <div class="shareShow" v-if="showWxShare" @click="onShareCancel">
      <div>
        <h2>点击分享给好友</h2>
      </div>
    </div>


    <van-popup v-model="show_share_panel" position="bottom" :style="{ height: '30%' }">
      <div class="share-panel">
        <div class="share-title">请选择分享方式</div>
        <!--<div class="share-desc">朋友通过你分享的页面成功报名后，你可获得对应的佣金。佣金可在会员中心-分销订单里查看</div>-->
        <div class="share-ul">
          <div class="share-weixin" @click="shareWeixinFriend">
            <p>微信好友</p>
          </div>
          <div class="share-timeline" @click="shareWeixinTimeLine">
            <p>朋友圈</p>
          </div>
          <div class="share-copy" v-clipboard:copy="copy_text"
               v-clipboard:success="function(){copySuccess();show_share_panel=false }">
            <p>复制链接</p>
          </div>
        </div>
      </div>
    </van-popup>

    <NavFloatShare @show="show_share_panel = true"></NavFloatShare>
  </div>

    			<LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel" />

  </div>
</template>
<style scoped>

    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }

.course—pic {
  width: 100%;
}
.no-pay {
  width: 1.5rem;
  height: 0.5rem;
  border-radius: 13px;
  border: 1px solid rgba(0, 0, 0, 1);
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 0.5rem;
  text-align: center;
  margin-right: 15px;
}
.on-pay {
  width: 1.5rem;
  height: 0.5rem;
  background: linear-gradient(
    90deg,
    rgba(254, 200, 53, 1) 0%,
    rgba(255, 173, 25, 1) 100%
  );
  border-radius: 13px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 0.5rem;
  text-align: center;
  margin-left: 15px;
}
.pay-show-bottom {
  width: 100%;
  height: 1.2rem;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
}
.block p {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 32px;
  text-align: center;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 6.1rem;
  height: 3.55rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  /* align-items: center; */
}
.bottom-course-price {
  height: 30px;
  font-size: 21px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(255, 71, 104, 1);
  line-height: 30px;
  margin-left: 10px;
}
.bottom-course {
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(17, 17, 17, 1);
  line-height: 20px;
}
.course-pay {
  width: 3.1rem;
  height: 44px;
  background: linear-gradient(
    90deg,
    rgba(254, 200, 53, 1) 0%,
    rgba(255, 173, 25, 1) 100%
  );
  border-radius: 22px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  line-height: 44px;
}
.course-bottom {
  width: 100%;
  height: 62px;
  background: rgba(255, 255, 255, 1);
  position: fixed;
  bottom: 0;
}
.content {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(68, 68, 68, 1);
  line-height: 30px;
  text-indent: 28px;
}
.course-content-title {
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(68, 68, 68, 1);
  line-height: 20px;
  /* padding-left: 10px; */
}
.course-content {
  /* margin-top: 20px; */
  border-radius: 10px 10px 0 0;
  background: #fff;
  padding: 10px 10px;
  /* padding-bottom: 50px; */
  margin-bottom: 10px;
}
.course-title-box {
  border-radius: 0 0 10px 10px;
  background: #fff;
  padding: 10px 0.2rem;
}
.course-detail-title {
  height: 21px;
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 21px;
}
.course-detail-info {
  display: flex;
  align-items: center;
  margin-top: 15px;
}
.course-detail-info .course-price {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(253, 40, 64, 1);
}
.course-detail-info .course-validity {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  margin-left: 10px;
}
.course-play {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  margin-top: 10px;
  height: 38px;
  /* opacity:0.08; */
}
.course-num,
.course-play-num {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}
.course-detail {
  /* width: 7.1rem; */
  margin: 0px auto;
}
.active-icon {
  background: red;
}
.course-info {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 0.85);
}
.course-title {
  /* height: 20px; */
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
  line-height: 20px;
}
.directory {
  width: 6.9rem;
  margin: 10px auto;
  padding-left: 10px;
  padding-bottom: 100px;
  background: rgba(255, 255, 255, 1);
  border-radius: 14px;
}
.box {
  /*margin-bottom: 1.5rem;*/
  background: #f8f8f8;
  height: 100%;
}
.box >>> .van-tabs__line {
  background: #00b388;
}
</style>
<script>
import Vue from "vue";
import LoginDialog from '@/components/LoginDialog.vue';
import NavFloatShare from "@/components/NavFloatShare.vue";
import {
  Tab,
  Tabs,
  List,
  PullRefresh,
  Toast,
  Step,
  Steps,
  Overlay,
  Empty
} from "vant";
Vue.use(Tab)
  .use(Tabs)
  .use(PullRefresh)
  .use(List)
  .use(Toast)
  .use(Step)
  .use(Steps)
  .use(Overlay)
  .use(Empty);
export default {
  name: "CourseDetail",
  components: {
    LoginDialog,NavFloatShare
  },
  data: function() {
    return {
				loginShow:false,
      active: 0,
      activeTab: [
        { name: "目录", num: 0 },
        { name: "介绍", num: 0 }
      ],
      pay_show: false,
      paly_show: false,
      course_id: 0,
      is_daka:false,
      videoActive: 0,
      row: {
        items: [],
        id_cert:false,
        danwei_cert:false,
      },
      item_id:0,
      play_url: "",

      copy_text: '',
      showWxShare: false,
      show_share_panel: false,
      share_data:{},
      isApp:false,
    };
  },
  filters: {},
  mounted() {
    let that = this;
    document.title = "课程详情";
    that.course_id = this.$route.query.id;
    if(window.isApp()){
      this.isApp = true
    }else{ 
      this.isApp = false
    }
    that.getCourseDetail();
    that.videoActive = localStorage.getItem("videoActive") || 0;
    that.setBrowse()
  },
  watch: {},
  destroyed() {},
  methods: {
    // toOrderCheck() {  
    //   rblink({ name: "CourseOrderCheck", query: { id: that.course_id } });
    // },
    setBrowse(){
      let arr=JSON.parse(localStorage.getItem('browseIds')) || []
        arr.map((item,i)=>{
          if(item==this.course_id){
            arr.splice(i,1)
          }
        })
          arr.push(this.course_id) 
        localStorage.setItem('browseIds',JSON.stringify(arr))
    },
    onPlayItems(i) {
      console.log(i);
      if(!this.row.id_cert){
        // return 
      }
      if(!this.row.danwei_cert){
        // return 
      }
      if(!this.isApp){
        // return 
      }
 
      if (this.row.need_pay == "2") {
        this.pay_show = true;
        return;
      }
      this.videoActive = i;
      this.paly_show = false;
      this.play_url = this.row.items[i].video_url;
      localStorage.setItem("videoActive", i);

      this.item_id =  this.row.items[i].id 
      this.is_daka =  this.row.items[i].is_daka 
      this.$api.post(
        "/api/course/courseItemsViewsCountAdd",
        { id: this.row.items[i].id },
        res => {
          console.log(res);
          this.row.items[i].views_count += 1;
          this.paly_show = true;
        },
        res => {
          Toast(res.msg);
        }
      );
    },
    getCourseDetail() {
      let that = this;
      this.$api.get(
        "/api/course/detail",
        { id: that.course_id },
        res => {
          console.log(res);
          that.row = res.data;


          that.share_data = res.data.share_data;
          that.copy_text = res.data.share_data.url;

          that.onPlayItems(0)
        },
        res => {
 
					if (res.code == 401 || res.code==402) {
						if(window.isApp()){
							rbLink({
								name:'login','query':{ }
							},'replace');
							return false;
						}
						that.loginShow = true
					}else {
						Toast(res.msg)
					}
        }
      );
    },
    onPlayShwo() {
      // this.pay_show = true;
      let that=this
      rbLink({ name: "CourseOrderCheck", query: { id: that.course_id } });

    },

			loginSuccess(res){
				console.log('-------登录成功--------',res);
				this.loginShow = false;
				this.fetch();
			},

			loginCancel(){
				console.log('-------取消登录--------');
				// this.loginShow = false;
			},
    daka(){
      let that = this;
      this.$api.get(
        "/api/course/courseItemDaka",
        { item_id: that.item_id },
        res => {
          console.log(res); 
          that.is_daka = true
        },
        res => {

					if (res.code == 401 || res.code==402) {
						if(window.isApp()){
							rbLink({
								name:'login','query':{ }
							},'replace');
							return false;
						}
						that.loginShow = true
					}else {
						Toast(res.msg)
					}
        }
      );
    },

    onShareCancel() {
      this.showWxShare = false;
    },


    shareWeixinFriend() {
      console.log('shareWeixinFriend')
      let that = this;
      if (window.isApp()) {
        appEvent({
          name: 'shareWeixinFriend',
          query: that.share_data
        });
      } else {
        this.showWxShare = true;
        this.show_share_panel = false;
      }
    },

    // 下载APP
    onDownload() {
      // 判断是ios还是安装
      if(window.isApp()) {
        if(window.isAndroid()) {
          appEvent({
            name: 'downloadFile',
            query: {
              name: 'file.name',
              url: "http://fir.dierqudao.com/859v",
            }
          });
          return
          rbLink({
            name: 'H5',
            query: {
              url: "http://fir.dierqudao.com/859v"
            }
          })


        } else {
// let url = URL(string: "itms-apps://itunes.apple.com/app/id 1142110895")
          appEvent({
            name: 'downloadFile',
            query: {
              name: 'file.name',
              url: "itms-apps://itunes.apple.com/app/1440159054",
            }
          });
          return
          rbLink({
            name: 'H5',
            query: {
              url: "itms-apps://itunes.apple.com/app/1440159054"
            }
          })
        }
      }
    },
    shareWeixinTimeLine() {
      let that = this;
      if (window.isApp()) {
        appEvent({
          name: 'shareWeixinTimeLine',
          query: that.share_data
        });
      } else {
        this.showWxShare = true;
        this.show_share_panel = false;

      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// CourseDetail.vue?03249f56